import { useQuery } from '@tanstack/react-query';
import { allChatSessionQueryOptions } from '@/hooks/sessions/use-conversation-sessions';
import type { ConversationSessionsTypeUnion, ConversationType } from '@/models/conversations/conversation-session';

export default function useSession<T = ConversationSessionsTypeUnion>(
  type: Nullable<ConversationType>,
  id: Nullable<number>,
) {
  const query = useQuery({
    ...allChatSessionQueryOptions,
    select: (data) => data.find((s) => s.SessionType === type && s.ID === id) as T,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return { session: query.data, ...query };
}
